
import React, { Component } from 'react';
// import { Box } from 'reactjs-admin-lte'
import { Popover, OverlayTrigger, Modal, Button, ButtonToolbar, DropdownButton, MenuItem, ControlLabel, Label, InputGroup, Form, FormGroup, Row, Col, FormControl } from 'react-bootstrap'
// import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import BackupcarStore from 'stores/BackupcarStore'
// import DatePicker from '../../component/element/DatePicker'
// import ConfirmPopup from '../../component/element/ConfirmPopup'
// import CKAutocomplete from '../../component/element/CKAutocomplete'
import { Checkbox } from 'react-icheck';
// import IframeModal from '../../component/element/IframeModal'
// import Select from 'react-select'
import {connect} from 'react-redux'
// import Moment from 'moment';
import ReportGeneralTable from 'view/report/ReportGeneralTable'
// const NotificationSystem = require('react-notification-system');
// const DEFAULT_ROW = 10

const cHeaderTitlesAll = [  
  {title:'วันที่ออกจ็อบ',width:'100px',keyField:"work_date"},  
  {title:'เลขอ้างอิง/ทะเบียนรถสำรอง',width:'200px',keyField:"ref_no"},
  {title:'ใบงานเลขที่',width:'220px',keyField:"work_no"},
  {title:'ทะเบียนรถ',width:'150px',keyField:"car_registration_no"},
  {title:'ยี่ห้อ',width:'150px',keyField:"brand"},
  {title:'รุ่น',width:'150px',keyField:"model"},  
  {title:'ประกัน',width:'200px',keyField:"insurer_name"},  
  {title:'สิทธิ์ที่ใช้',width:'50px',keyField:"used_duration"},
  {title:'ระหว่างวันที่',width:'150px',keyField:"used_period"},
  {title:'ชื่อลูกค้า',width:'200px',keyField:"customer_name"},
  {title:'เบอร์ลูกค้า',width:'100px',keyField:"customer_tel"},
  {title:'วันที่-เวลาคืนรถ',width:'100px',keyField:"return_datetime"},     
  {title:'สถานะงานซ่อม',width:'100px',keyField:"work_status"}  
]
class ReportAppointmentReturn extends Component {

  constructor(...args) {
    super(...args)
    this.state = this.initState()
  }
  initState(){
    return {activePage:0,start:0}
  }

  renderStatus(status,row){
    let result = (<span></span>)

    if (row.work_status==='0') {
      result = (<span className="label label-default" data-value="0"><FontAwesome name='clock-o'/> เริ่มต้น</span>)
    }else if (row.work_status==='1') {
      result = (<span className="label label-warning" data-value="1"><FontAwesome name='wrench'/> อยู่ระหว่างซ่อม</span>)
    } else if (row.work_status==='2') {
      result = (<span className="label label-primary" data-value="2"><FontAwesome name='hourglass-start'/> รอส่งมอบรถ</span>)
    } else if (row.work_status==='3') {
      result = (<span className="label label-success" data-value="3"><FontAwesome name='thumbs-o-up'/> ปิดจบงาน</span>)
    } else if (row.work_status==='5') {
      result = (<span className="label label-purple" data-value="5"><FontAwesome name='bitcoin'/> ตั้งเบิก</span>)
    } else{
      result = (<span></span>)
    }

    if(row.doc_status!==undefined && row.doc_status*1===2){
      result = (<div>{result}<span  className="label label-success"><FontAwesome name='money'/> ชำระเงินแล้ว</span></div>)
    }
    if(row.doc_cancel!==undefined && row.doc_cancel*1===1){
      result = (<div>{result}<span  className="label label-danger"><FontAwesome name='trash'/> ยกเลิก</span></div>)
    }

    if(row.doc_cancel_remark!==undefined && row.doc_cancel_remark!==''){
      result = (<div>{result}<span  className="label label-danger"><FontAwesome name='trash'/> {row.doc_cancel_remark}</span></div>)
    }

    return result
  }

  loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback){
    
    BackupcarStore.loadAppointmentReturnList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
      this.processData(result)
      this.setState({activePage:activePage,start:activePage*itemPerPage})
      callback(result)
    })
  }

  processData(){

  }

  loadDataRange(){

  }

  onRenderColumn(data){
    return (<div>{data}</div>)
  }

  onRenderKeyColumn(data,key,row,rowIndex) {
    let {check,activeKey} = this.state
    if(key==="check"){
      return (<Checkbox    
        onChange={this.onCheckChange.bind(this,rowIndex)}      
        checked={check[rowIndex]!==false?true:false}
        checkboxClass="icheckbox_square-blue"
        increaseArea="20%"
        label=""
        disabled={row.work_status==='3'?true:false}
      />)      
    }else if(key==="work_no"){
      return this.renderWorkNo(row[key],row)     
    }else if(key==="work_status"){
      return this.renderStatus(data,row)
    } else{ 
      return (<span>{row[key]}</span>)
    }
  }

  renderWorkNo(data,row){
    if (data!=="" && data!==null) {
      let title = "ใบงานซ่อม "+data
      let popoverHoverFocus = (
        <Popover id="popover-trigger-hover-focus" title={title}>
          <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
        </Popover>
      )

      return (
        <span>
          {data} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconClick.bind(this,data)} className="text-blue" name='file-text-o'/></OverlayTrigger>
        </span>
      )
    }else{
      return (<span>{data}</span>)  
    } 
  }

  onIconClick(workNo,e) {
    this.refs.jsWork.loadData(workNo)
  }


  render (){
      let headerTitles = cHeaderTitlesAll

      let keyFieldList = headerTitles.reduce((result,item,index)=>{
        if(item.keyField){
          result.push(item.keyField)
        }
        return result
      },[])
      const searchOptions = [
        {
          label: 'ทะเบียนรถ',
          value: 'car_registration_no'
        },
        {
          label: 'ใบงานเลขที่',
          value: 'work_no'
        },
        {
          label: 'เลขอ้างอิง/ทะเบียนรถสำรอง',
          value: 'ref_no'
        },
        {
          label: 'ชื่อลูกค้า',
          value: 'customer_name'
        },
        {
          label: 'บริษัทประกัน',
          value: 'insurance_name'
        }
      ]
      return (
        <ReportGeneralTable 
        ref={'apptReturn'}
        title='ตารางนัดหมายรถสำรองใช้' 
        docType="backupcar"
        showNewButton={false}
        showPrintButton={false}
        showSelectMenu={false}
        showCreate={false}
        headerTitles={headerTitles}
        excludeColumn={[]}
        excludeClickColumn={[]}
        bodyColumn={keyFieldList}
        searchOptions={searchOptions}          
        searchBy={'car_registration_no'}
        loadData={this.loadData.bind(this)}    
        loadDataRange={this.loadDataRange.bind(this)}            
        onRenderColumn={this.onRenderKeyColumn.bind(this)}  
        minWidth={1300}
        isMobile={this.props.isMobile}
        mobileFieldMap={{title:'customer_name',amount:'amount',sub_title:'bill_no',date:'doc_date',status:'work_status',sub_status:''}}
      />
      )
  }
}

ReportAppointmentReturn.defaultProps = {
  
}

export default connect(
  (state) => ({messages: state.message.view.backupcar.BackupCarRegistration}),null,null,{withRef:true}
)(ReportAppointmentReturn);




// WEBPACK FOOTER //
// ./src/view/backupcar/ReportAppointmentReturn.js